'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBillingAdminSelector = exports.authStateSelector = exports.authSelector = undefined;

var _Scopes = require('pricing-pages-unified-ui/constants/Scopes');

var _Scopes2 = _interopRequireDefault(_Scopes);

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authSelector = exports.authSelector = function authSelector(state) {
  return state.auth;
};
var authStateSelector = exports.authStateSelector = function authStateSelector(state) {
  return state.authState;
};

// Permissions to make changes/buy products that require purchases
var isBillingAdminSelector = exports.isBillingAdminSelector = (0, _reselect.createSelector)(authSelector, function (auth) {
  // This check is only for if we dual-deploy and have non-auth
  if (!auth || !auth.user || !auth.user.scopes) {
    return false;
  }

  var scopeList = auth.user.scopes;

  var hasHubBillingWrite = scopeList.some(function (scope) {
    return scope === _Scopes2.default.BILLING_WRITE;
  });

  return hasHubBillingWrite;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/AuthAdminSelectors.js
// module id = 191
// module chunks = 3 4 5